import { BaseModel } from '../common/base-model/base-model';

export class Priority extends BaseModel {
  constructor(
    public override id?: string,
    public name?: string,
    public description?: string,
    public color?: string,
    public isActive?: boolean,
    public weight?: number,
    public owner_root_entity_id?: string,
    public target_entity_id?: string,
  ) {
    super();
  }

  static fromJson(jsonData: any): Priority {
    const priority = Object.assign(new Priority(), jsonData);

    if (
      jsonData.weight !== null &&
      jsonData.weight !== undefined &&
      jsonData.weight !== ''
    ) {
      priority.weight = Number(jsonData.weight);
    } else {
      priority.weight = null;
    }

    if (jsonData.isActive !== undefined) {
      priority.isActive =
        jsonData.isActive === 1 ||
        jsonData.isActive === true ||
        jsonData.isActive === 'true';
    }

    return priority;
  }
}
